import { graphql } from 'react-relay';

export const specialRelationshipsPastQuery = graphql`
  query employmentSpecialRelationshipsPastQuery($refundHistoryId: String!) {
    getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {
      result
      employmentAnswer {
        hasSpecialRelationshipsInThePast
        specialRelationshipsInThePast {
          indvTin
          ieNm
          birthday
          attrYears
        }
      }
    }
  }
`;

export const specialRelationshipsPastToCurrentlyQuery = graphql`
  query employmentSpecialRelationshipsPastToCurrentlyQuery($refundHistoryId: String!) {
    getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {
      result
      employmentAnswer {
        specialRelationshipsInThePast {
          indvTin
          ieNm
          birthday
          attrYears
        }
        specialRelationshipsCurrently {
          birthday
          ieNm
        }
      }
    }
  }
`;

export const specialRelationshipsCurrentQuery = graphql`
  query employmentSpecialRelationshipsCurrentQuery($refundHistoryId: String!) {
    getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {
      result
      employmentAnswer {
        specialRelationshipsCurrently {
          ieNm
          birthday
        }
      }
    }
  }
`;

export const contractsQuery = graphql`
  query employmentContractsQuery($refundHistoryId: String!) {
    getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {
      result
      employmentAnswer {
        hasEmploymentContracts
      }
    }
  }
`;
